export interface IContinueButtonClickHandlerParams {
  hasClaimedOtpAccount: boolean;
  isLockedOut: boolean;
  hasDuplicateAccountError: boolean;
  hasDuplicateLeadError: boolean;
  history: {
    push: (path: string) => void;
  };
  setIsClaimedOtpAccountModalOpen: (isClaimedOtpAccountModalOpen: boolean) => void;
  setIsOtpContactSalesModalOpen: (isOtpContactSalesModalOpen: boolean) => void;
  setIsDuplicateAccountErrorModalOpen: (isDuplicateAccountErrorModalOpen: boolean) => void;
  setIsDuplicateLeadErrorModalOpen: (isDuplicateLeadErrorModalOpen: boolean) => void;
  redesignV2RoutePath: { PURCHASE: string };
  CheckoutRoutePath: { INFO: string };
}

export const continueButtonClickHandler = ({
  hasClaimedOtpAccount,
  isLockedOut,
  hasDuplicateAccountError,
  hasDuplicateLeadError,
  history,
  setIsClaimedOtpAccountModalOpen,
  setIsOtpContactSalesModalOpen,
  setIsDuplicateAccountErrorModalOpen,
  setIsDuplicateLeadErrorModalOpen,
  redesignV2RoutePath,
  CheckoutRoutePath,
}: IContinueButtonClickHandlerParams): void => {
  if (hasClaimedOtpAccount) {
    setIsClaimedOtpAccountModalOpen(true);
  } else if (isLockedOut) {
    setIsOtpContactSalesModalOpen(true);
  } else if (hasDuplicateAccountError) {
    setIsDuplicateAccountErrorModalOpen(true);
  } else if (hasDuplicateLeadError) {
    setIsDuplicateLeadErrorModalOpen(true);
  } else {
    history.push(redesignV2RoutePath.PURCHASE + CheckoutRoutePath.INFO);
  }
};
